"use client"

import { getActiveMenuItemId } from "@/components/header-group/utils"
import { StructuredMenu } from "@/components/header-one/menu-structure"
import { useLocaleSwitcherLinks } from "@/hook/use-locale-switcher-links"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { HeaderDesktop } from "./header-desktop"
import { HeaderMobile } from "./header-mobile"

type HeaderViewClientProps = {
  locale: string
  structuredMenu: StructuredMenu
  headerLogoUrl?: string
}

export function HeaderViewClient({ locale, structuredMenu, headerLogoUrl }: HeaderViewClientProps) {
  const localeLinks = useLocaleSwitcherLinks(locale)
  const [activeItemId, setActiveItemId] = useState<number | null>(null)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isMenuClosing, setIsMenuClosing] = useState(false)
  const [openSubMenus, setOpenSubMenus] = useState<Set<number>>(new Set())
  const pathname = usePathname()

  const handleCloseMenu = () => {
    setIsMenuClosing(true)
    // setTimeout(() => {
    setIsMobileMenuOpen(false)
    setIsMenuClosing(false)
    setOpenSubMenus(new Set())
    // }, 300)
  }

  const handleMobileMenuToggle = () => {
    if (isMobileMenuOpen) {
      handleCloseMenu()
    } else {
      setIsMobileMenuOpen(true)
    }
  }

  const handleToggleSubMenu = (itemId: number) => {
    const newOpenSubMenus = new Set(openSubMenus)
    if (newOpenSubMenus.has(itemId)) {
      newOpenSubMenus.delete(itemId)
    } else {
      newOpenSubMenus.add(itemId)
    }
    setOpenSubMenus(newOpenSubMenus)
  }

  useEffect(() => {
    const activeId = getActiveMenuItemId(structuredMenu, pathname, locale)
    setActiveItemId(activeId)
  }, [pathname, structuredMenu, locale])

  useEffect(() => {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false)
      setOpenSubMenus(new Set())
    }
  }, [pathname])


  return (
    <>
      <HeaderDesktop locale={locale} structuredMenu={structuredMenu} activeItemId={activeItemId} localeLinks={localeLinks} headerLogoUrl={headerLogoUrl} />
      {/* Spacer for desktop header to prevent content overlap */}
      <div className="hidden lg:block h-[74px]" />
      <HeaderMobile
        locale={locale}
        structuredMenu={structuredMenu}
        isMobileMenuOpen={isMobileMenuOpen}
        isMenuClosing={isMenuClosing}
        openSubMenus={openSubMenus}
        localeLinks={localeLinks}
        onMenuIconClick={handleMobileMenuToggle}
        onCloseMenu={handleCloseMenu}
        onToggleSubMenu={handleToggleSubMenu}
      />
      {/* Spacer for mobile header to prevent content overlap */}
      <div className="block lg:hidden h-[110px]" />
    </>
  )
}
